export class InvitationEntrepriseService {
  constructor(private readonly apiUrl: string) {}

  async send(idEntreprise: number, email: string) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/${idEntreprise}/invitation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: `"${email}"`,
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de la création de l'invitation:", error);
      throw error;
    }
  }

  async checkToken(token: string) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/invitation/${token}/check`,
        {
          method: "GET",
          cache: "no-store",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }

      return await resultat.json();
    } catch (error) {
      //console.error("Erreur lors de la récupération des cours:", error);
      throw error;
    }
  }

  async accept(token: string) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/invitation/${token}/accept`,
        {
          method: "PATCH",
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors de l'acceptation de l'invitation:", error);
      throw error;
    }
  }

  async refuse(token: string) {
    try {
      const resultat = await fetch(
        `${this.apiUrl}/api/entreprises/invitation/${token}/refuse`,
        {
          method: "PATCH",
        },
      );

      if (!resultat.ok) {
        throw new Error(`Erreur HTTP: ${resultat.status}`);
      }
    } catch (error) {
      console.error("Erreur lors du refus de l'invitation:", error);
      throw error;
    }
  }
}
